module.exports = __webpack_public_path__ + "8708555cd0fbd52c1312870e38287e17.jpg";